export var DEFAULT_TOAST_TIMEOUT = 150;
export var DEFAULT_TOAST_CLASSNAMES = {
    appear: "rmd-toast--enter",
    appearActive: "rmd-toast--enter-active",
    enter: "rmd-toast--enter",
    enterActive: "rmd-toast--enter-active",
    exit: "rmd-toast--exit",
    exitActive: "rmd-toast--exit-active",
};
//# sourceMappingURL=constants.js.map